<template>
    <section class="technologies" :id="$t('routes.tech')" :ref="$t('routes.tech')" >
        <div class="sloth-container">
            <h3 class="section-title text-center">
                {{ $t('tech.title')}}
            </h3>
            <p class="our-technologies-description">
                 {{ $t('tech.description')}}
            </p>

            <div class="our-technologies">
                <a 
                    v-for="(item, key) in tech" :key="key"
                    :href="item.url" 
                    class="our-technologies-item">
                    <img 
                        :src="item.icon" 
                        alt=""
                    >
                </a>
            </div>
        </div>
    </section>

</template>

<script>
    export default {
        name: "OurTech",
        data() {
            return {
                tech: [
                    {
                        link: '',
                        icon: '/assets/images/techs/angular.jpg'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/vue.jpg'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/react.jpg'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/django.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/sass.jpg'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/adobe.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/mongodb.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/postgresql.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/mysql.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/nodejs.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/aws.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/digital-ocean.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/docker.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/jenkings.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/kotlin.png'
                    },
                    {
                        link: '',
                        icon: '/assets/images/techs/android.png'
                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>